import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import Layout from 'components/Layout'
import CustomTendersComponent from 'components/CustomTenders'
import ListFilters from 'components/CustomTenders/ListFilters'

import { getCurrentVenueUuid } from 'store/Venues/selector'
import { fetchFilteredAndPaginatedCustomPaymentTypes } from 'store/CustomPaymentTypes/actions'
import { getQueryStringParameters } from 'store/AppState/selector'
import { loadRevenueCenters } from 'store/RevenueCenters/actions'
import { isEmpty } from 'lodash'

const CustomTenders = () => {
  const dispatch = useDispatch()
  const { pathname } = useLocation()

  const venueUuid = useSelector(getCurrentVenueUuid)
  const queryStringParameters = useSelector((state) =>
    getQueryStringParameters(state, pathname)
  )

  useEffect(() => {
    dispatch(
      fetchFilteredAndPaginatedCustomPaymentTypes({
        ...queryStringParameters,
        venueUuid,
      })
    )

    if (!isEmpty(venueUuid)) {
      dispatch(loadRevenueCenters(venueUuid))
    }
    
  }, [venueUuid, dispatch])

  return (
    <Layout
      isSidebar
      navbarContent={
        <ListFilters
          queryStringParametersWithVenue={{
            ...queryStringParameters,
            venueUuid,
          }}
        />
      }
      mainContent={<CustomTendersComponent />}
    />
  )
}

export default CustomTenders
